import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import TaskDetailsView from '../components/TaskDetailsView';
import TaskForm from '../components/TaskForm';
import ProjectForm from '../components/ProjectForm';
import Task from '../components/Task';
import { TaskProvider } from '../../../../core/components/tasks/TaskProvider';
import { ProjectProvider } from '../../../../core/components/projects/ProjectProvider';
import { OrgProvider } from '../../../../core/components/orgs/OrgProvider';
import { UserProvider } from '../../../../core/components/users/UserProvider';
import { CampaignOrderProvider } from '../../../../core/components/campaingOrder/CampaignOrderProvider';
import ProjectDetails from '../components/ProjectDetails';

const TaskManagementRoutes = (props) => {
  const { path } = props.match;
  document.title = `Task Management`;
  return (
    <UserProvider>
      <OrgProvider>
        <CampaignOrderProvider>
          <ProjectProvider>
            <TaskProvider>
              <Switch>
                <Route path={`${path}/projects`} exact render={() => <Task {...props} />} />
                <Route path={`${path}/projects/new`} exact render={() => <ProjectForm />} />
                <Route path={`${path}/projects/details/:id?`} exact render={() => <ProjectDetails />} />
                <Route path={`${path}/main/:pageNumber?`} exact render={() => <Task {...props} />} />
                <Route path={`${path}/unassigned/:pageNumber?`} exact render={() => <Task {...props} />} />
                <Route path={`${path}/form/:id?`} exact render={() => <TaskForm />} />
                <Route path={`/tasks/details/:id?`} exact render={() => <TaskDetailsView />} />
                <Route path={`${path}/overdue`} exact render={() => <Task {...props} />} />
                {/* Fallback - check if PLATFORM user */}
                <Route path={`${path}`} render={() => {
                  const isPlatformLevel = props.currentUser?.role?.org?.level === 'PLATFORM';
                  return isPlatformLevel
                    ? <Redirect to={`${path}/projects`} />
                    : <Redirect to={`${path}/main/1`} />;
                }} />
              </Switch>
            </TaskProvider>
          </ProjectProvider>
        </CampaignOrderProvider>
      </OrgProvider>
    </UserProvider>
  );
};

export default TaskManagementRoutes;
